// components/SignInForm.jsx
import { useContext, useState } from "react";
import { signOut, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import { auth, db } from "../contexts/firebase";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function SignInForm() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const navigate = useNavigate();
    
    const sendLoginLink = async () => {
        if (!email) {
            return;
        }
        const docRef = doc(db, "allowed_emails", email);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
            alert("please contact Sira")
            return;
        }

        try {
            await signInWithEmailAndPassword(auth, email, password)
            await navigate('/homedb')
        } catch (err) {
            alert(err)
        }
    };

    return (
        <div>
            
            <h2>Sign In</h2>
            
            <>
                <Form.Control type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                <Form.Control type='password' value={password} onChange={(e) => setPassword(e.target.value)} />
                <Button variant="dark" onClick={sendLoginLink}>Go</Button>
            </>
        </div>
    );
}


const PageSignIn = () => {

    const { isSignIn } = useContext(AuthContext)

    const navigate = useNavigate();

    const onSignOut = async () => {        
        try {
            await signOut(auth);
            alert("Signed out successfully!");
        } catch (error) {
            alert("Failed to sign out.");
        }
    }

    return (
        <div>
            <br /><br /><br /><br />
            <Row>
                
                <Col md={{offset: 4, span: 4}} xs='12' className="main-comp">
                    {isSignIn ? (
                        <ButtonGroup>
                            <Button variant="danger" onClick={onSignOut}>Sign Out</Button> 
                            <Button variant="primary" onClick={() => navigate('/homedb')}>Go to dashboard</Button> 
                        </ButtonGroup>
                    )
                        
                        : <SignInForm />
                    }
                </Col>
            </Row>
        </div>
    )
}

export default PageSignIn